<template>
  <svg
    class="svg-icon"
    :class="`svg-icon--${size}`"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    preserveAspectRatio="xMinYMin"
  >
    <use :xlink:href="`#img-${iconName}`" />
  </svg>
</template>



<script>
  export default {
    name: 'SvgIcon',

    props: {
      iconName: {
        type: String,
        required: true
      },
      size: {
        type: String,
        required: false,
        default: 'standard'
      }
    }
  };
</script>
